import { RouteConfig } from 'vue-router';

import { templateManageRoute } from './manage.route';

export const templateAddRoute: RouteConfig = templateManageRoute('add', 'templateAdd', 'Tworzenie wzoru procedury', [
  { title: 'Nazwa', name: 'templateAddName' },
  { title: 'Statusy', name: 'templateEditStatuses' }
]);
